import React from 'react';
import PageLayout from '../components/PageLayout';
import GalleryPage from '../components/GalleryPage';
import usePageMeta from '../hooks/usePageMeta';

export default function GalleryRoutePage() {
  usePageMeta(
    'Gallery | Hotel Respiro — São Vicente, Cabo Verde',
    'Photos of Hotel Respiro: lodge rooms, private villas, beach bar, pool and explorations across São Vicente and Santo Antão islands.'
  );

  return (
    <PageLayout>
      <div data-testid="gallery-page">
        <GalleryPage />
      </div>
    </PageLayout>
  );
}
